import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { CookieService } from "src/app/core/services/cookie.service";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-add-user-district",
  templateUrl: "./add-user-district.component.html",
  styleUrls: ["./add-user-district.component.scss"],
})
export class AddUserDistrictComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  userDistrict: FormGroup;
  submitted: boolean;
  currentUser: any;
  notfoundshow: boolean;
  isLoading: boolean = false;
  isLoading1: boolean;
  keyword = "name";
  keyword1 = "Area";
  areas: any;
  propertyType: any;
  bankList: any;
  UserID: any;
  PropertyId: any;
  initialValue = "";
  loanTypes: any;
  DistrictList: any;
  District: any[];
  baseDocType: any;
  date: Date = new Date();
  fieldsData: any[];
  DataList: any = {};
  URL: string;
  dynamicFields = [];
  stateID: any;
  isImageUploaded = false;
  StateBaseDocType: any;
  param: string;
  PropertyData: any;
  Editproperty: boolean;
  Type: any;
  id: any;
  StateList_1: any[];
  user: any;

  constructor(
    private service: GeneralService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private cookie: CookieService,
    private datepipe: DatePipe,
    private Fb: FormBuilder,
    private router: Router
  ) {
    this.Type = this.route.snapshot.params.type;

    if (this.router.getCurrentNavigation()) {
      if (this.router.getCurrentNavigation().extras.state) {
        const state = this.router.getCurrentNavigation().extras.state;

        this.UserID = state["UserId"];
        this.id = state["id"];
        console.log(state, "state district");

        localStorage.setItem("id", state.id);
      } else {
        if (localStorage.getItem("UserId")) {
          this.UserID = localStorage.getItem("UserId");
        }
      }
    }
    // console.log("UserID", this.UserID);
    this.breadCrumbItems = [
      { label: "User District", path: "/users/userDistrcit" },
      { label: "Add User District", path: "/", active: true },
    ];
  }

  ngOnInit() {
    this.getusersbyid();
    this.currentUser = JSON.parse(this.cookie.getCookie("currentUser"));

    // this.getNoticeData(this.UserID);
    this.submitted = false;
    this.currentUser = this.service.getcurrentUser();
    this.userDistrict = this.Fb.group({
      UserID: new FormControl(this.UserID),

      DistrictID: new FormControl(null, Validators.required),
    });
    this.fetchdistrictlist();
  }
  save1() {
    this.submitted = true;
    if (this.userDistrict.valid) {
      this.submitted = false;

      this.userDistrict.controls.UserID.setValue(this.UserID);
      this.userDistrict["UserID"] = this.UserID;
      delete this.userDistrict.value.DistrictID;
      if (this.Type != "edit") {
        // console.log("line==151", this.StateList_1[0]);

        let payload = {
          UserID: this.UserID,
          DistrictID: this.StateList_1[0].DistrictID,
        };
        console.log(payload, "Payload");

        this.service.addUserDistrict(payload).subscribe((res: any) => {
          this.submitted = false;
          if (res.status == 200) {
            Swal.fire({
              position: "top-end",
              type: "success",
              title: "User district Added SuccessFully",
              showConfirmButton: false,
              timer: 1500,
            });
            this.isLoading = false;
            this.router.navigate(["users/userDistrcit"]);
          } else if (res.status == 400) {
            Swal.fire({
              position: "top-end",
              type: "info",
              title: res.message,
              showConfirmButton: false,
              timer: 1500,
            });

            this.router.navigate(["users/userDistrcit"]);
          }
          this.userDistrict.reset();

          this.isLoading = false;
        });
      }
    }
  }
  get f() {
    return this.userDistrict.controls;
  }
  fetchdistrictlist() {
    this.service.viewDistrictlist().subscribe((res: any) => {
      this.District = res;
      // console.log("DistrictList", this.District);
    });
  }
  onclear() {
    this.userDistrict.controls.DistrictID.setValue(null);
    this.userDistrict.controls.district.setValue(null);
  }

  resetFields() {
    this.userDistrict.reset();

    this.submitted = false;
  }
  ChangeState(e: any) {
    console.log(e, "District......");
    this.StateList_1 = this.District.filter(
      (s) => s.DistrictName == e.$ngOptionLabel
    );
    console.log("liune218", this.StateList_1);
  }
  resetForm() {
    this.userDistrict.controls.district.setValue("");

    this.dynamicFields.forEach((element) => {
      this.userDistrict.removeControl(element);
    });
    this.DistrictList = [];
  }
  getusersbyid() {
    this.isLoading = true;
    this.service.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanId", this.user.plan_id);
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
}
